import { FunctionComponent, ReactElement } from 'react';
import { Box, BoxProps, Text } from '@chakra-ui/react';

type NumberChartCardProps = BoxProps & {
  label: string;
  value: string | number | ReactElement;
  variant?: 'brand' | 'green' | 'orange' | 'red';
};

const valueColorByVariant = {
  brand: 'brand.500',
  green: 'green.600',
  orange: 'orange.500',
  red: 'red.600',
};

const NumberChartCard: FunctionComponent<NumberChartCardProps> = props => {
  const { label, value, variant = 'brand', ...rest } = props;

  return (
    <Box backgroundColor='white' p={6} borderRadius='10px' boxShadow='0 1px 2px 0 rgba(0, 0, 0, 0.16)' {...rest}>
      <Text fontWeight='bold' lineHeight='normal' color='text.main'>
        {label}
      </Text>
      <Text
        fontWeight='semibold'
        fontSize={{ base: '40px', xl: '80px' }}
        lineHeight='normal'
        color={valueColorByVariant[variant]}
      >
        {value}
      </Text>
    </Box>
  );
};

export { NumberChartCard };
